<!-- Regular icon button when not a menu item -->
@if (!isMenuItem()) {
<button matIconButton type="button" (click)="open()" #tooltip="matTooltip" aria-label="Session Details"
      matTooltip="Session Details" matTooltipPosition="below">
      <mat-icon class="material-symbols-outlined icon-sm" aria-hidden="true" fontIcon="info" />
</button>
} @else {
<button mat-menu-item type="button" (click)="open()">
      <mat-icon class="material-symbols-outlined icon-sm" aria-hidden="true" fontIcon="info" />
      <span>Session Details</span>
</button>
}
